"use strict";
/**
 * Copyright (c) Haiku 2016-2018. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var marshalParams_1 = require("./marshalParams");
function functionSpecificationToFunction(name, params, body, type) {
    if (type === void 0) { type = 'FunctionExpression'; }
    var fn;
    if (type === 'ArrowFunctionExpression') {
        // tslint:disable-next-line:no-function-constructor-with-string-args
        fn = new Function('\n' +
            'return ' +
            (name || '') +
            '(' +
            marshalParams_1.default(params) +
            ') => {\n' +
            '  ' +
            (body || '') +
            '\n' +
            '}\n')();
    }
    else {
        // tslint:disable-next-line:no-function-constructor-with-string-args
        fn = new Function('\n' +
            'return function ' +
            (name || '') +
            '(' +
            marshalParams_1.default(params) +
            ') {\n' +
            '  ' +
            (body || '') +
            '\n' +
            '}\n')();
    }
    return fn;
}
exports.default = functionSpecificationToFunction;
//# sourceMappingURL=functionSpecificationToFunction.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@haiku/core/lib/reflection/functionSpecificationToFunction.js
// module id = 136
// module chunks = 35783957827783 127651196306611 162898551421021